import { useFormDetailsQuery } from '../../public/lib/PublicQueries.js';
import React, { useEffect } from 'react';

export const FormContext = React.createContext({});

export function calculateEventQuantity(formData) {
    if (!formData) {
        return 0;
    }

    const startTimes = {};
    for (const a of Object.values(formData)) {
        if (Array.isArray(a)) {
            for (const entry of a) {
                if (entry?.startTime) {
                    startTimes[entry?.startTime] =
                        (startTimes[entry?.startTime] || 0) + 1;
                }
            }
        }
    }

    return Math.max(0, Math.max(...Object.values(startTimes)));
}

export function calculateExtraTime(formData) {
    if (!formData) {
        return 0;
    }

    let extraTime = 0;
    for (const a of Object.values(formData)) {
        if (Array.isArray(a?.addons)) {
            for (const entry of a.addons) {
                if (entry?.addon?.duration) {
                    extraTime += entry?.addon?.duration * entry?.quantity;
                }
            }
        }
    }

    return extraTime;
}

const FormContextProvider = ({
    children,
    businessId,
    formId,
    formData,
    setFormData,
    sections,
}) => {
    const { data, isLoading } = useFormDetailsQuery(businessId, formId);

    useEffect(() => {}, []);

    // Figure out how many people we're booking for and provide that data
    // total guests are the total number of repeated start times
    const eventQuantity = calculateEventQuantity(formData);
    const extraTime = calculateExtraTime(formData);

    return (
        <FormContext.Provider
            value={{
                ...data,
                eventQuantity,
                extraTime,
                submission: {
                    setFormData,
                    formData,
                    sections,
                },
            }}
        >
            {children}
        </FormContext.Provider>
    );
};

export default FormContextProvider;
